import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/style_legal_pages.css";
import {formatPhoneFR} from "../utils/validators";
import { useGlobalProperty } from "../context/GlobalPropertyContext";

export default function MentionsLegales() {
  const navigate = useNavigate();
  const { globalProperties, loading: globalLoading } = useGlobalProperty();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back-btn" onClick={() => navigate(-1)}><ion-icon name="arrow-back-outline"></ion-icon>Retour</button>

        <header className="legal-header">
          <h1>Mentions Légales</h1>
          <p className="legal-subtitle">{globalProperties?.enterprise_info?.social_reason}</p>
        </header>

        <article className="legal-content">
          
          <section className="legal-section">
            <h2>1. Responsable du Site</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason !== "" && <><strong>Entreprise : </strong>{globalProperties?.enterprise_info?.social_reason || ""}<br /></>}
              {globalProperties?.enterprise_info?.dirigent_last_name !== "" && globalProperties?.enterprise_info?.dirigent_first_name !== ""  && <><strong> Presidente Directrice Générale : </strong> Mme {(globalProperties?.enterprise_info?.dirigent_last_name?.toUpperCase() || "") + " " + (globalProperties?.enterprise_info?.dirigent_first_name[0]?.toUpperCase() + globalProperties?.enterprise_info?.dirigent_first_name.slice(1) || "")} <br /></>}
              {globalProperties?.enterprise_info?.social_status !== "" && <><strong>Forme juridique : </strong>{globalProperties?.enterprise_info?.social_status || ""}<br /></>}
              {globalProperties?.enterprise_info?.social_capital !== "" && <><strong>Capital social : </strong>{globalProperties?.enterprise_info?.social_capital || ""}<br /></>}

              {globalProperties?.enterprise_info?.siret !== "" && <><strong>SIRET : </strong>{globalProperties?.enterprise_info?.siret || ""}<br /></>}

              {globalProperties?.enterprise_info?.rcs !== "" && <><strong>RCS : </strong>{globalProperties?.enterprise_info?.rcs || ""}<br /></>}
              {globalProperties?.enterprise_info?.vat_number !== "" && <><strong>TVA Intracommunautaire : </strong>{globalProperties?.enterprise_info?.vat_number || ""}<br /></>}
              {globalProperties?.address?.street !== "" && globalProperties?.address?.postal_code !== "" && globalProperties?.address?.city !== "" && globalProperties?.address?.country !== "" && <>
                <strong>Adresse : </strong>{
                  (globalProperties?.address?.street || "") + ", " + 
                  (globalProperties?.address?.postal_code || "") + ", " + 
                  (globalProperties?.address?.city || "") + ", " + 
                  (globalProperties?.address?.country || "")}<br />
              </>}
              {globalProperties?.contacte?.phone !== "" && <><strong>Téléphone : </strong>{formatPhoneFR(globalProperties?.contacte?.phone || "")}<br /></>}
              {globalProperties?.contacte?.email !== "" && <><strong>Email : </strong>{globalProperties?.contacte?.email || ""} </>}
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Hébergement du Site</h2>
            <p>
              {globalProperties?.hebergeur?.name !== "" && <><strong>Hébergeur : </strong>{globalProperties?.hebergeur?.name || ""}<br /></>}
              {globalProperties?.hebergeur?.street !== "" && globalProperties?.hebergeur?.postal_code !== "" && globalProperties?.hebergeur?.city !== "" && globalProperties?.hebergeur?.country !== "" && <>
                <strong>Adresse : </strong>{
                  (globalProperties?.hebergeur?.street || "") + ", " + 
                  (globalProperties?.hebergeur?.postal_code || "") + ", " + 
                  (globalProperties?.hebergeur?.city || "") + ", " + 
                  (globalProperties?.hebergeur?.country || "")}<br />
              </>}
              {globalProperties?.hebergeur?.phone !== "" && <><strong>Téléphone : </strong>{formatPhoneFR(globalProperties?.hebergeur?.phone || "")}<br /></>}
              {globalProperties?.hebergeur?.email !== "" && <><strong>Email : </strong>{globalProperties?.hebergeur?.email || ""}</>}
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Propriété Intellectuelle</h2>
            <p>
              Le site latelierfloral.fr est la propriété exclusive de {globalProperties?.enterprise_info?.social_reason}. Tous les éléments du site (textes, images, vidéos, graphiques, logos, etc.) sont protégés par le droit d'auteur et les droits de propriété intellectuelle.
            </p>
            <p>
              Toute reproduction, adaptation, modification ou transmission du contenu sans l'autorisation écrite préalable de {globalProperties?.enterprise_info?.social_reason} est interdite.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Limitation de Responsabilité</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} s'engage à mettre à jour régulièrement le contenu du site. Cependant, il ne peut être tenu responsable des inexactitudes, omissions ou interruptions du service.
            </p>
            <p>
              {globalProperties?.enterprise_info?.social_reason} décline toute responsabilité concernant :
            </p>
            <ul>
              <li>Les dommages directs ou indirects résultant de l'accès au site</li>
              <li>Les dysfonctionnements techniques du serveur</li>
              <li>Les pertes de données ou les interruptions de service</li>
              <li>L'utilisation du site par des tiers non autorisés</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Conditions d'Utilisation</h2>
            <p>
              L'utilisateur s'engage à utiliser le site de manière conforme à la loi et aux bonnes mœurs. Il est notamment interdit de :
            </p>
            <ul>
              <li>Reproduire ou représenter le contenu du site sans autorisation</li>
              <li>Utiliser le site à des fins commerciales ou publicitaires non autorisées</li>
              <li>Introduire des virus, codes malveillants ou tout autre élément nuisible</li>
              <li>Accéder à des zones réservées ou contourner les mesures de sécurité</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Cookies et Données Personnelles</h2>
            <p>
              Le site utilise des cookies pour améliorer votre expérience utilisateur. Vous pouvez configurer votre navigateur pour refuser les cookies ou être averti avant leur installation.
            </p>
            <p>
              Pour plus d'informations sur le traitement de vos données personnelles, veuillez consulter notre <a href="/politique-confidentialite" className="legal-link">Politique de Confidentialité</a>.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Contact et Réclamations</h2>
            <p>
              Pour toute question concernant ces mentions légales ou le fonctionnement du site, vous pouvez nous contacter à :
            </p>
            <p>
              {globalProperties?.contacte?.email !== "" && <><strong>Email : </strong>{globalProperties?.contacte?.email || ""}<br /></>}
              {globalProperties?.contacte?.phone !== "" && <><strong>Téléphone : </strong>{formatPhoneFR(globalProperties?.contacte?.phone || "")}</>}
            </p>
          </section>

          <section className="legal-section last">
            <h2>8. Droit Applicable</h2>
            <p>
              Ces mentions légales sont régies par la loi française. Tout litige sera soumis à la juridiction compétente du tribunal de Montpellier.
            </p>
            <p className="legal-date">
              <em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</em>
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}